module.exports = __webpack_public_path__ + "static/media/card.90c40b00.png";